<template>
  <div class="material-card">
    <div class="card-header">
      <div class="title-wrap">
        <h4 class="title">{{title || '材料题'}}</h4>
        <el-radio-group v-model="materialType"
                        @change="handleMaterialTypeChange">
          <el-radio :label="1">图文材料</el-radio>
          <el-radio :label="2">音频材料</el-radio>
        </el-radio-group>
        <div class="editor">
          <el-switch v-model="editTypes"
                     active-text="百度编辑器"
                     inactive-text="默认编辑器"
                     @change="editChange">
          </el-switch>

        </div>
      </div>
      <div class="menu-wrap">
        <slot></slot>
      </div>
    </div>
    <div class="exam-material">
      <div class="upload-wrap"
           v-if="materialType == 2">
        <div class="label">
          上传音频材料：
        </div>
        <el-upload class="uploader"
                   :action="imgUploadUrl"
                   :headers="uploadHeaders"
                   :show-file-list="true"
                   :file-list="fileList"
                   :before-upload="handleBeforeUpload"
                   :on-success="handleUploadSuccess">
          <el-button size="small"
                     type="primary"
                     icon="el-icon-upload2"
                     plain>点击上传</el-button>
        </el-upload>
        <p class="tip">支持扩展名：.mp3 .WAV .FLC</p>
        <div class="audio-box"
             v-if="resource.url">
          <audio controls>
            <source :src="resource.url"
                    type="audio/mpeg">
            您的浏览器不支持 audio 元素。
          </audio>
        </div>
      </div>
      <div class="exam-description"
           v-if="materialType == 1">
        <VueEditor v-if="!editTypes"
                   :content="richText"
                   @change="handleRichTextChange"
                   placeholder="请输入材料描述" />
        <UEeditor v-else
                  :setDataStr="richText"
                  placeholder="请输入题目，为确保智能组卷功能，题目中无需输入序号数字"
                  @change="handleRichTextChange" />
      </div>
      <div class="formula"
           v-if="richText&&richText.includes('$')">
        <div class="top">检测到包含LaTex公式，预览如下</div>
        <div class="bottom">
          <LatexRenderer :content="richText" />
        </div>
      </div>
    </div>
    <div class="exam-sub-wrap">
      <div class="exam-item"
           v-for="(item, $index) in itemList"
           :key="item.key">
        <Single v-if="item.answer_type === 0"
                :title="`${keys[$index]} 单选题`"
                :content="item"
                @save="handleExamSave($event, $index)">
          <div style="display: flex;">
            <div v-if="$index != 0">
              <el-button type="text"
                         @click="handleExamSortChange($index, 'up')">上移</el-button>
              <el-divider class="divider"
                          direction="vertical"></el-divider>
            </div>
            <div v-if="$index != itemList.length-1">
              <el-button type="text"
                         @click="handleExamSortChange($index, 'down')">下移</el-button>
              <el-divider class="divider"
                          direction="vertical"></el-divider>
            </div>
            <el-button type="text"
                       @click="handleExamRemove($index)">删除</el-button>
          </div>
        </Single>
        <Multiple v-if="item.answer_type === 1"
                  :title="`${keys[$index]} 多选题`"
                  :content="item"
                  @save="handleExamSave($event, $index)">
          <div style="display: flex;">
            <div v-if="$index != 0">
              <el-button type="text"
                         @click="handleExamSortChange($index, 'up')">上移</el-button>
              <el-divider class="divider"
                          direction="vertical"></el-divider>
            </div>
            <div v-if="$index != itemList.length-1">
              <el-button type="text"
                         @click="handleExamSortChange($index, 'down')">下移</el-button>
              <el-divider class="divider"
                          direction="vertical"></el-divider>
            </div>
            <el-button type="text"
                       @click="handleExamRemove($index)">删除</el-button>
          </div>
        </Multiple>
        <Judge v-if="item.answer_type === 3"
               :title="`${keys[$index]} 判断题`"
               :content="item"
               @save="handleExamSave($event, $index)">
          <div style="display: flex;">
            <div v-if="$index != 0">
              <el-button type="text"
                         @click="handleExamSortChange($index, 'up')">上移</el-button>
              <el-divider class="divider"
                          direction="vertical"></el-divider>
            </div>
            <div v-if="$index != itemList.length-1">
              <el-button type="text"
                         @click="handleExamSortChange($index, 'down')">下移</el-button>
              <el-divider class="divider"
                          direction="vertical"></el-divider>
            </div>
            <el-button type="text"
                       @click="handleExamRemove($index)">删除</el-button>
          </div>
        </Judge>
        <Qa v-if="item.answer_type === 4"
            :title="`${keys[$index]} 自测题`"
            :content="item"
            @save="handleExamSave($event, $index)">
          <div style="display: flex;">
            <div v-if="$index != 0">
              <el-button type="text"
                         @click="handleExamSortChange($index, 'up')">上移</el-button>
              <el-divider class="divider"
                          direction="vertical"></el-divider>
            </div>
            <div v-if="$index != itemList.length-1">
              <el-button type="text"
                         @click="handleExamSortChange($index, 'down')">下移</el-button>
              <el-divider class="divider"
                          direction="vertical"></el-divider>
            </div>
            <el-button type="text"
                       @click="handleExamRemove($index)">删除</el-button>
          </div>
        </Qa>
      </div>
      <div class="exam-add">
        <p>+添加子问题</p>
        <div class="exam-buttons">
          <el-button type="primary"
                     @click="handleExamItemAdd(0)">单选题</el-button>
          <el-button type="primary"
                     @click="handleExamItemAdd(1)">多选题</el-button>
          <el-button type="primary"
                     @click="handleExamItemAdd(3)">判断题</el-button>
          <el-button type="primary"
                     @click="handleExamItemAdd(4)">问答题</el-button>
        </div>
      </div>
    </div>
    <specials :visible="dialogVisible"
              @echo="echo"
              @readName="readName"
              :content="content"
              @close="dialogVisible = false">
    </specials>
    <div class="zhi"
         @click="concatStudy()">选择关联知识点：
      <el-tag v-if="nameflag"> {{nameflag}}</el-tag>
    </div>
  </div>
</template>

<script>
import LatexRenderer from '@/components/formula/formulaGeneration.vue'
import VueEditor from '@/components/VueEditor'
import UEeditor from '@/components/UEeditor.vue'
import Single from '@/components/exam/Single'
import Multiple from '@/components/exam/Multiple'
import Judge from '@/components/exam/Judge'
import Qa from '@/components/exam/Qa'
import { randomTimeNumber, getFileExtendingName } from '@/utils/helper'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import { uploadFileToken, resourceUpdate } from '@/api/common'
import {
  examItemUpdate,
  examChapterOne,
  examPaperOne,
  examPaperItemList,
  examPaperItemCreate,
  examPaperItemUpdate,
  examPaperItemsUpdate,
  examPaperItemDestroy,
} from '@/api/exam'

let Timer = null // 定时器
let TimerTime = 500 // 定时器 等待时长

export default {
  components: {
    LatexRenderer,
    specials: () => import('@/components/exam/special.vue'),
    UEeditor,
    VueEditor,
    Single,
    Multiple,
    Judge,
    Qa,
  },
  props: {
    title: String,
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
    itemLists: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    itemLists: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.filterItem = this.itemLists.filter(
            (v) => v.item_id == this.content.item_id
          )

          setTimeout(() => {
            this.nameflag = this.filterItem[0].readName
          }, 500)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      editTypes: false,
      dialogVisible: false,
      fileList: [],
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      keys: `ABCDEFGHIJKLMNOPQRSTUVWXYZ`.split(''),
      materialType: this.content.material_type || 1,
      richText: this.content.rich_text,
      resource: this.content.resource || {
        url: '',
      },
      itemList: this.content.children || [],
      nameflag: '',
      filterItem: [],
    }
  },
  methods: {
    editChange(val) {
      this.editTypes = val
    },
    concatStudy() {
      this.dialogVisible = true
      // this.$refs.childLevelRelevancy.open(this.id, 2)
    },
    readName(val) {
      this.$set(this.content, 'readName', val)
      // this.$emit('shuxin')
    },
    echo(val, item) {
      this.concatItem = item.name
      this.cncatId = item.id
    },
    // 文件上传前处理
    handleBeforeUpload(file) {
      return true
    },
    // 文件上传成功回调
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        if (this.resource.id) {
          let values = {
            id: this.resource.id,
            name: res.data.name,
            key: res.data.url,
            url: res.data.url,
            size: file.size,
            type: 2,
          }
          if (file.raw && file.raw.type) {
            values['mime_type'] = file.raw.type
          }
          resourceUpdate(values)
            .then((res2) => {
              this.resource = res2
              this.fileList = []
              // 数据向外层传递
              this.handleExamSaveAll()
            })
            .catch((error) => {
              this.$message.error('音频材料更新异常')
              console.log('error: ', error)
            })
        }
      } else {
        this.$message.error(res.error)
      }
    },
    // 材料类型变化
    handleMaterialTypeChange(value) {
      examItemUpdate({ id: this.content.item_id, material_type: value })
        .then((res) => {
          if (value == 2) {
            this.resource.id = res.resource_id
          }
          // 数据向外层传递
          this.handleExamSaveAll()
        })
        .catch((error) => {
          this.$message.error('材料类型更新异常')
          console.log('error: ', error)
        })
    },
    // 图文资料
    handleRichTextChange(editor) {
      if (this.editTypes) {
        this.richText = editor
      } else {
        this.richText = editor.html
      }
      // this.richText = editor.html
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        examItemUpdate({ id: this.content.item_id, rich_text: this.richText })
          .then((res) => {
            // 数据向外层传递
            this.handleExamSaveAll()
          })
          .catch((error) => {
            this.$message.error('图文材料更新异常')
            console.log('error: ', error)
          })
      }, TimerTime)
    },
    // 题目保存
    handleExamSave(event, index) {
      this.itemList[index].content = event
      // 数据向外层传递
      this.handleExamSaveAll()
    },
    // 题目排序
    handleExamSortChange(index, type) {
      let old = this.itemList.splice(index, 1)[0]
      if (type == 'up') {
        this.itemList.splice(index - 1, 0, old)
      } else if (type == 'down') {
        this.itemList.splice(index + 1, 0, old)
      }
      const rows = this.itemList.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      examPaperItemsUpdate(rows)
        .then((res) => {
          // 数据向外层传递
          this.handleExamSaveAll()
        })
        .catch((error) => {
          this.$message.error('题目排序更新异常')
          console.log('error: ', error)
        })
    },
    // 题目删除
    handleExamRemove(index) {
      // 二次确认撤销
      this.$confirm(
        '确定要删除吗？题目被多处引用时，进行删除操作可能会产生不良影响，请谨慎操作。',
        '提示',
        {
          confirmButtonText: '确定删除',
          type: 'warning',
        }
      )
        .then(() => {
          examPaperItemDestroy({ id: this.itemList[index].id }).then((res) => {
            this.itemList.splice(index, 1)
            // 数据向外层传递
            this.handleExamSaveAll()
          })
        })
        .catch(() => {})
    },
    // 题目添加
    handleExamItemAdd(type) {
      let itemValue = {
        paper_id: this.content.paper_id,
        pid: this.content.item_id,
        answer_type: type,
        sort: this.itemList.length,
      }
      if (type === 8) {
        itemValue.material = 1
      }
      examPaperItemCreate(itemValue).then((res) => {
        this.itemList.push(res)
        // 数据向外层传递
        this.handleExamSaveAll()
      })
    },
    handleExamSaveAll() {
      this.$emit('save', {
        materialType: this.materialType,
        material: this.material,
        itemList: this.itemList,
      })
    },
  },
}
</script>

<style scoped lang="less">
.zhi {
  margin-top: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #0091ff;
  font-size: 16px;
}
.material-card {
  position: relative;
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  padding: 20px;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .title-wrap {
      display: flex;

      .title {
        font-size: 18px;
        font-weight: bold;
        color: #0091ff;
        margin-right: 20px;
      }
      .editor {
        position: absolute;
        left: 65%;
      }
      /deep/ .el-radio {
        margin-right: 20px;
      }
      /deep/ .el-radio__label {
        padding-left: 5px;
      }
    }
    .menu-wrap {
      display: flex;
      align-items: center;

      /deep/ .el-button {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }
  .exam-material {
    background: #fff;
    // padding: 20px 0;
    margin: 20px 0;
  }
  .upload-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .tip {
      font-size: 12px;
      color: #999;
      margin-left: 10px;
    }
  }
  .audio-box {
    margin-left: 20px;

    audio {
      outline: none;
    }
  }
  .vueEditor {
    /deep/ .ql-container {
      min-height: 80px;
    }
  }
  .formula {
    width: 100%;
    background: #f9f9f9;
    border: 1px solid #d4d1d1;
    .top {
      font-weight: 700;
      padding-left: 15px;
      width: 100%;
      line-height: 68px;
      border-bottom: 1px solid #d4d1d1;
    }
    .bottom {
      width: 100%;
      min-height: 80px;
      max-height: 300px;
      overflow-y: auto;
    }
  }
  .formulas {
    width: 400px;
    background: #f9f9f9;
    border: 1px solid #d4d1d1;
    .top {
      font-weight: 700;
      padding-left: 15px;
      width: 100%;
      line-height: 68px;
      border-bottom: 1px solid #d4d1d1;
    }
    .bottom {
      width: 100%;
      min-height: 80px;
      max-height: 300px;
      overflow-y: auto;
    }
  }
  .exam-sub-wrap {
    .exam-item {
      margin-top: 20px;
    }
    .exam-add {
      position: relative;
      color: #303133;
      background-color: #fff;
      border: 1px dashed #0091ff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      overflow: hidden;
      padding: 20px;
      margin-top: 20px;

      display: flex;
      flex-direction: column;
      align-items: center;

      .exam-buttons {
        margin-top: 10px;

        /deep/ .el-button {
          padding: 10px 30px;
          margin: 0 20px;
        }
      }
    }
  }
}
</style>
